import { render } from "./FormSC.vue?vue&type=template&id=66e36880&scoped=true"
import script from "./FormSC.vue?vue&type=script&lang=js"
export * from "./FormSC.vue?vue&type=script&lang=js"

import "./FormSC.vue?vue&type=style&index=0&id=66e36880&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e36880"]])

export default __exports__